export const SET_QUOTE = 'onboarding:set-quote'
export const RESET = 'onboarding:reset'
export const SET_ACTIONS_OPEN = 'onboarding:actions:set:open'
export const SET_ACTIONS_TEXT = 'onboarding:actions:set:text'
export const SET_CAN_STEP_FORWARD = 'onboarding:can-step-forward:set'
export const SET_CAN_SKIP_STEP = 'onboarding:can-skip-step:set'
export const PUSH_RAW_DATA = 'onboarding:push-raw-data'
export const SET_RAW_DATA = 'onboarding:raw-data:set'
export const SET_INITIAL_STEP_DATA = 'onboarding:initial-step-data:set'
export const PUSH_COMPLETED_SECTION = 'onboarding:completed-section:push'
export const PUSH_COMPLETED_SEGMENT = 'onboarding:completed-segment:push'
export const SET_ACTIVE = 'onboarding:active:set'
export const SET_DISCOUNT = 'onboarding:discount-code:set'
export const SET_NAVIGATION_OPEN = 'onboarding:navigation-open:set'
export const SET_SELECTED_DOG = 'onboarding:selected-dog:set'
